import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';

import { RegionService } from '../../services/region.service';

@Component({
  selector: 'send-success-page',
  templateUrl: 'send-success.html'
})
export class SendSuccessPage {
  showSuccess: boolean;
  constructor(
    public regionService: RegionService,
    public viewCtrl: ViewController,
    public navParams: NavParams
  ) {
    this.showSuccess = this.navParams.get('showSuccessMessage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/send-success/send-success.ts